<template><article><h1>一般用法</h1>
<h3 id="单个滑块"><a class="header-anchor" href="#单个滑块" aria-hidden="true">#</a> 单个滑块</h3>
<p><example :value="example1"></example></p>
<h3 id="多个滑块"><a class="header-anchor" href="#多个滑块" aria-hidden="true">#</a> 多个滑块</h3>
<p><example :value="example2"></example></p>
<h3 id="设置值的范围"><a class="header-anchor" href="#设置值的范围" aria-hidden="true">#</a> 设置值的范围</h3>
<p><example :value="example3"></example></p>
<h3 id="设置滑块方向"><a class="header-anchor" href="#设置滑块方向" aria-hidden="true">#</a> 设置滑块方向</h3>
<p><example :value="example4"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<ul>
<li><code v-pre>ltr</code> 代表着 <code v-pre>left to right</code>，即自左向右的水平滑块。<code v-pre>rtl/btt/ttb</code> 同理</li>
<li>当 <code v-pre>direction</code> 的值为 <code v-pre>btt</code> 或 <code v-pre>ttb</code> 时，需要给定组件一个高度</li>
</ul>
</div>
<h3 id="懒更新"><a class="header-anchor" href="#懒更新" aria-hidden="true">#</a> 懒更新</h3>
<p>只有当拖拽结束后，值才会更新。</p>
<p><example :value="example5"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p>如果你需要使用拖拽时组件的内部值，你可以监听 <code v-pre>dragging</code> 事件或者使用 <code v-pre>default slot</code>.</p>
</div>
<h3 id="禁用滑块"><a class="header-anchor" href="#禁用滑块" aria-hidden="true">#</a> 禁用滑块</h3>
<p>可以使用 <code v-pre>disabled</code> 禁用整个组件，也可以使用 <code v-pre>dot-options</code> 单独禁用滑块。</p>
<p><example :value="example6"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>禁用单个滑块时，请使用 <code v-pre>order = false</code> 或者 <code v-pre>enableCross = true</code>。</p>
</div>
<h3 id="吸附效果"><a class="header-anchor" href="#吸附效果" aria-hidden="true">#</a> 吸附效果</h3>
<p>设置 <code v-pre>adsorb</code> 为 <code v-pre>true</code> 时，滑块自动吸附到最近的值。</p>
<p><example :value="example7"></example></p>
<h3 id="边缘对齐"><a class="header-anchor" href="#边缘对齐" aria-hidden="true">#</a> 边缘对齐</h3>
<p>默认情况下使用 <code v-pre>dot</code> 的中心来对齐边界。</p>
<p>当 <code v-pre>contained</code> 设置为 <code v-pre>true</code>，则使用 <code v-pre>dot</code> 的边缘对齐。</p>
<p><example :value="example8"></example></p>
<h3 id="点击时拖拽"><a class="header-anchor" href="#点击时拖拽" aria-hidden="true">#</a> 点击时拖拽</h3>
<p>设置 <code v-pre>drag-on-click</code> 为 <code v-pre>true</code> 时，可以在点击进度条时直接拖拽滑块。</p>
<p><example :value="example9"></example></p>
</article></template>

<script>
  import examples from '@/examples/simple.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>